<template>
  <el-container>
      <el-row>
        <el-col :span="5">
            <div><img class="left-logo" :src="leftlogo.src" alt=""><p>{{leftlogo.text}}</p></div>
        </el-col>
        <el-col :span="5" :offset="14">
            <div><img class="right-logo" :src="rightlogo.src" alt=""><p>{{rightlogo.text}}</p><p class="login" @click="handleLogin" v-if="!token">登录</p></div>
        </el-col>
      </el-row>
  </el-container>
</template>

<script>
import dayeelogo from '../assets/img/dayeelogo.png'
import logo from '../assets/img/logo.png'
import constant from '../utils/constant'
export default {
  data () {
    return {
      token: '',
      leftlogo: {
        text: '接口平台',
        src: dayeelogo
      },
      rightlogo: {
        text: '上海大易云科技有限公司',
        src: logo
      }
    }
  },
  mounted () {
    console.log(33, sessionStorage.getItem('token'))
    this.token = sessionStorage.getItem('token')
  },
  methods: {
    handleLogin () {
      const pathPre = constant.pathPre
      this.$router.push({path: pathPre + '/Login/Index'})
    }
  }
}
</script>

<style scoped>
.el-container{
    background-color: #B3C0D1;
    width: 100%;
    height: 90px !important;
    background: #373D42 0% 0% no-repeat padding-box;
    opacity: 1;
}
.el-row{
    width: 100%;
}
.el-col div{
    display:flex;
    justify-content: center;
    align-items: center;
}
.el-col img,p{
    display: inline-block;
    line-height: 90px;
}
.el-col p{
    color: #ffffff;
    padding-left: 16px;
}
.el-col .login{
    cursor: pointer;
}
.el-col .login:hover{
  color:rgb(24, 144, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/PgHeader.vue